<script>
import { mapActions, mapGetters } from "vuex";
import AlertError from "@/components/alert_error";
import Loader from "@/components/widgets/loader";
import { swal } from "../../../helpers/handle_error";
import exportToExcel from "../../../helpers/export_to_excel";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import { required, maxLength } from "vuelidate/lib/validators"; // for validators
import statuses from "../../../helpers/list/statuses.json";

export default {
  components: { AlertError, Loader },
  data() {
    return {
      //Page errors.
      errors: [],
      showLoader: true,
      showAlert: false,
      loadingButton: false,
      submited: false,
      tableKey:1,
      showModel:false,

      status_note: "",
      status: "",
      statusClassList: {
        PENDING: "bg-warning",
        REJECTED: "bg-danger",
        ACCEPTED: "bg-primary",
        FINAL_ACCEPTED: "bg-success",
      },
      statusList: statuses,

      student: "",

      items: [],

      // datatable
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      totalItems: 0,
      totalItemsFiltered: 0,
      pageOptions: [
        10,
        25,
        50,
        100,
        { value: Number.MAX_SAFE_INTEGER, text: "عرض الكل" },
      ],
      filter: "",
      filterOn: [],

      sortBy: "created_at",
      sortDesc: true,

      fields: [
        {
          // A virtual column that doesn't exist in items
          label: "التسلسل",
          key: "index",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: true,
          name: "",
          searchable: false,
        },
        {
          label: "الاسم الرباعي",
          key: "full_name",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: false,
          name: "full_name",
          searchable: true,
        },
        {
          label: "الفئة",
          key: "category.title",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: false,
          name: "category.title",
          searchable: true,
        },
        {
          label: "المحافظة",
          key: "address.city.title",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: false,
          name: "address.city.title",
          searchable: true,
        },
        {
          label: "رقم الهاتف",
          key: "phone",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: false,
          name: "phone",
          searchable: true,
        },
        {
          label: "التحصيل الدراسي",
          key: "certificate_info.certificate.title",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: false,
          name: "certificateInfo.certificate.title",
          searchable: true,
        },
        {
          label: "التخصص",
          key: "certificate_info.specialization",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: false,
          name: "certificateInfo.specialization",
          searchable: true,
        },
        {
          label: "الدراسة المتقدم لها",
          key: "certificate_info.new_certificate.title",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: false,
          name: "certificateInfo.newCertificate.title",
          searchable: true,
        },
        {
          label: "تاريخ التقديم",
          key: "created_at",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: false,
          name: "created_at",
          searchable: true,
        },
        {
          label: "حالة القبول",
          key: "status",
          class: "col-acceptance-status",
          sortable: false,
          visible: true,
          //for join datatable.
          isVirtual: true,
          name: "",
          searchable: false,
        },
        {
          label: "الاجراءات",
          key: "settings",
          class: "col-setting-services-scholar_ships",
          sortable: false,
          visible: this.$store.getters["auth/getUser"].hasAnyPermission([
            "show_details_scholarships",
            "delete_scholarships",
          ]),
          //for join datatable.
          isVirtual: true,
          name: "",
          searchable: false,
        },
      ],
    };
  },
  // vuelidate
  validations: {
    status: { required },
    status_note: { maxLength: maxLength(1000) },
  },
  computed: {
    ...mapGetters("scholarshipsStudent", ["getStudents"]),
    start() {
      return (this.currentPage - 1) * this.perPage + 1;
    },
    end() {
      return Math.min(this.currentPage * this.perPage, this.totalItemsFiltered);
    },
  },
  methods: {
    visibleFields() {
      return this.fields.filter((field) => field.visible);
    },
    handleError(error) {
      alert(error);
      this.showAlert = true;
      if (error.response.status == 422)
        this.errors = Object.values(error.response.data.errors);
      else
        this.errors = [
          `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
        ];
    },
    ...mapActions("scholarshipsStudent", ["getAll", "delete", "updateStatus"]),
    search() {
      if (this.currentPage == 1) this.fetchAll(true);
      else this.currentPage = 1;
    },
    fetchAll(is_search) {
      if (!is_search) {
        this.showLoader = true;
      }

      var query = new URLSearchParams({
        draw: this.currentPage,
        start: (this.currentPage - 1) * this.perPage,
        length: this.perPage,
      });
      query.append("_datatable", "1");
      let columns = this.fields.filter((f) => !f.isVirtual);
      columns.forEach((el, index) => {
        query.append("columns[" + index + "][data]", el.name);
        query.append("columns[" + index + "][name]", el.name);
        query.append("columns[" + index + "][orderable]", el.sortable);
        query.append("columns[" + index + "][searchable]", el.searchable);
        query.append("columns[" + index + "][search][value]", "");
        query.append("columns[" + index + "][search][regex]", "false");
      });
      query.append("search[value]", this.filter);
      query.append("search[regex]", "false");

      query.append("order[0][column]", 7);
      query.append("order[0][dir]", "desc");

      this.getAll(query)
        .then((response) => {
          this.totalItemsFiltered = response.data.recordsFiltered;
          this.totalItems = response.data.recordsTotal;

          this.items = this.getStudents;
          this.showLoader = false;
        })
        .catch((error) => {
          this.handleError(error);
          this.showLoader = false;
        });
    },
    async deleteItem(id) {
      if (await swal.confirm()) {
        swal.loading();
        this.delete(id)
          .then((response) => {
            this.fetchAll();
            swal.success(response.data.message);
          })
          .catch((error) => {
            this.handleError(error);
            swal.close();
          });
      }
    },
    exportTable() {
      exportToExcel(this.visibleFields(), this.items, "أستمارة المنح الدراسية");
    },
    // saveAsPDF
    saveAsPDF() {
      const element = this.$refs.printcontent;

      html2canvas(element, { scale: 3 }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "cm", "a4");
        pdf.addImage(imgData, "PNG", 0, 0, 21, 29.7);
        pdf.save("document.pdf");
      });
    },
    showPDF(id) {
      this.student = this.getStudents.find((s) => s.id == id);
    },
    showStatus(id) {
      this.student = this.getStudents.find((s) => s.id == id);
      this.status = this.student.student_status.id;
      this.status_note = this.student.status_note;
      this.showModel = true;
      this.$bvModal.show("modal-status");
    },
    resetModal() {
      this.errors = [];
      this.student = "";
      this.status = "";
      this.status_note = "";
      this.loadingButton = false;
      this.$v.$reset();
      this.showModel = false;
      this.showAlert = false;
      this.$bvModal.hide("modal-status");
    },
    refreshTable() {
      this.tableKey += 1; // تحديث قيمة المفتاح لإعادة الرندر
    },
    dataChange() {
      return (
        this.student.status_note != this.status_note ||
        this.student.student_status.id != this.status
      );
    },
    saveStatus() {
      if (!this.dataChange()) return;

      this.submited = true;
      this.$v.$touch();
      if (this.$v.$error) return;

      // to form submit after this
      this.loadingButton = true;
      this.errors = [];

      let data = {
        id: this.student.id,
        student_status_id: this.status,
        status_note: this.status_note,
      };

      this.updateStatus(data)
        .then((response) => {
          this.refreshTable();
          swal.success(response.data.message);
          this.resetModal();
        })
        .catch((error) => {
          this.handleError(error);
          this.loadingButton = false;
        });
    },
  },
  watch: {
    currentPage: {
      handler: function () {
        this.fetchAll();
      },
    },
    perPage: {
      handler: function () {
        this.fetchAll();
      },
    },
  },
  created() {
    this.fetchAll();
  },
  mounted() {},
};
</script>

<template>
  <div>
    <!-- start modal-pdf -->
    <b-modal
      id="modal-pdf"
      centered
      title-class="font-18"
      hide-footer
      v-if="typeof student == 'object'"
      @hidden="resetModal"
    >
      <template #modal-title>
        <b-button @click="saveAsPDF" class="btn-sm" variant="info"
          >تحميل الاستمارة بصيغة (pdf)</b-button>
      </template>
      <div class="scholar-ships-print" ref="printcontent">
        <div class="center">
          <div class="text-center">
            <img src="@/assets/images/logo.png" class="logo" alt="" />
            <p class="mb-0 font-size-16">المديرية العامة للعلاقات والخدمات الاجتماعية</p>
            <p class="mb-3 font-size-12">
              استمارة طلب منحة للدراسة في جامعات الجمهورية الاسلامية الايرانية للطلاب غير
              الايرانيين
            </p>
          </div>
          <h5 style="width: 151px">المعلومات الشخصية :</h5>
          <hr class="title-line" />
          <div class="row mb-3">
            <div class="col-md-4">
              <p><strong class="mx-1">الاسم :</strong>{{ student.full_name }}</p>
              <p><strong class="mx-1">تاريخ التولد :</strong>{{ student.birth_date }}</p>
              <p>
                <strong class="mx-1">فصيلة الدم :</strong>{{ student.blood_type?student.blood_type.title:'' }}
              </p>
              <p><strong class="mx-1">المهنة :</strong>{{ student.job?student.job.title:'' }}</p>
              <p><strong class="mx-1">مكان العمل :</strong>{{ student.job_details }}</p>
            </div>
            <div class="col-md-4">
              <p><strong class="mx-1">اللقب :</strong>{{ student.family_name }}</p>
              <p><strong class="mx-1">الجنس :</strong>{{ student.gender?student.gender.title:'' }}</p>
              <p><strong class="mx-1">الديانة :</strong>{{ student.religion?student.religion.title:'' }}</p>
              <p>
                <strong class="mx-1">الحالة الاجتماعية :</strong
                >{{ student.marital_status?student.marital_status.title:'' }}
              </p>
              <p>
                <strong class="mx-1">رقم الجواز :</strong>{{ student.passport_number }}
              </p>
            </div>
            <div class="col-md-4">
              <p>
                <strong class="mx-1">اسم الام الثلاثي :</strong>{{ student.mother_name }}
              </p>
              <p><strong class="mx-1">رقم الهاتف :</strong>{{ student.phone }}</p>
              <p><strong class="mx-1">تاريخ التقديم :</strong>{{ student.created_at }}</p>
              
              <!-- فقط اذا كان متزوج  -->
              <p v-if="student.marital_status.id != 1 && student.marital_status.id != 5">
                <strong class="mx-1">عدد الاطفال :</strong>{{ student.number_children }}
              </p>

              <p>
                <strong class="mx-1">تاريخ نفاذ الجواز :</strong
                >{{ student.passport_expire }}
              </p>
            </div>
          </div>

          <h5 style="width: 100px">عنوان السكن :</h5>
          <hr class="title-line" />
          <div class="row mb-3">
            <div class="col-md-4">
              <p>
                <strong class="mx-1">المحافظة :</strong>{{ student.address.city?student.address.city.title:'' }}
              </p>
              <!---->
            </div>
            <div class="col-md-4">
              <p><strong class="mx-1">المنطقة :</strong>{{ student.address.region }}</p>
              <!---->
            </div>
            <div class="col-md-4">
              <p>
                <strong class="mx-1">اقرب نقطة دالة :</strong
                >{{ student.address.nearest_point }}
              </p>
              <!---->
            </div>
          </div>

          <h5 style="width: 197px">معلومات التحصيل الدراسي :</h5>
          <hr class="title-line" />
          <div class="row mb-3">
            <div class="col-md-4">
              <p>
                <strong class="mx-1">التحصيل الدراسي :</strong>
                {{ student.certificate_info.certificate?student.certificate_info.certificate.title:'' }}
              </p>
              <p>
                <strong class="mx-1">سنة التخرج :</strong>
                {{ student.certificate_info.graduation_year }}
              </p>
              <p>
                <strong class="mx-1">التخصص الدراسي :</strong>
                {{ student.certificate_info.specialization }}
              </p>
              <p>
                <strong class="mx-1">المعدل :</strong>{{ student.certificate_info.avg }}
              </p>
            </div>
            <div v-if="student.certificate_info.certificate.id != 1" class="col-md-4">
              <p>
                <strong class="mx-1">اسم القسم :</strong
                >{{ student.certificate_info.department_name }}
              </p>
              <p>
                <strong class="mx-1">اسم الجامعة :</strong>
                {{ student.certificate_info.university_name }}
              </p>
              <p><strong class="mx-1">نوع الدراسة :</strong>
              {{ student.certificate_info.study_time_type.title }}
              </p>
              <p>
                <strong class="mx-1">هل تمت معادلة الشهادة :</strong>
                {{ student.certificate_info.certificate_equalized ? "نعم" : "لا" }}
              </p>
            </div>
            <div v-if="student.certificate_info.certificate.id != 1" class="col-md-4">
              <p>
                <strong class="mx-1">مكان الدراسة :</strong> 
                {{ student.certificate_info.study_location_type?student.certificate_info.study_location_type.title:'' }}
              </p>
              <p>
                <strong class="mx-1">اسم الكلية :</strong>
                {{ student.certificate_info.college_name }}
              </p>
              <p>
                <strong class="mx-1">نوع الجامعة :</strong>
                {{ student.certificate_info.university_type?student.certificate_info.university_type.title:'' }}
              </p>
            </div>
          </div>

          <h5 style="width: 266px">معلومات الدراسة المتقدم لها الطالب :</h5>
          <hr class="title-line" />
          <div class="row mb-3">
            <div class="col-md-12">
              <p>
                <strong class="mx-1">المستوى الدراسي :</strong
                >{{ student.certificate_info.new_certificate?student.certificate_info.new_certificate.title:'' }}
              </p>
              <p>
                <strong class="mx-1">التخصص الدراسي الاول الذي ترغب فيه :</strong
                >{{ student.certificate_info.choice1 }}
              </p>
              <p>
                <strong class="mx-1">التخصص الدراسي الثاني الذي ترغب فيه :</strong
                >{{ student.certificate_info.choice2 }}
              </p>
              <p>
                <strong class="mx-1">التخصص الدراسي الثالث الذي ترغب فيه :</strong
                >{{ student.certificate_info.choice3 }}
              </p>
            </div>
          </div>

          <h5 style="width: 100px">فئة المتقدم :</h5>
          <hr class="title-line" />
          <div class="row mb-3">
            <div class="col-md-12">
              <p><strong class="mx-1">الفئة :</strong>{{ student.category?student.category.title:'' }}</p>
            </div>
            <div class="col-md-12">
              <p>
                <strong class="mx-1">تفاصيل العمل التطوعي :</strong
                >{{ student.volunteer_details }}
              </p>
            </div>
          </div>

          <h5 style="width: 65px">المعرف :</h5>
          <hr class="title-line" />
          <div class="row">
            <div class="col-md-6">
              <p>
                <strong class="mx-1">اسم المعرف :</strong>{{ student.broker_full_name }}
              </p>
            </div>
            <div class="col-md-6">
              <p><strong class="mx-1">مكان العمل :</strong>{{ student.broker_job }}</p>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- end modal-pdf -->

    <!-- start modal-pdf -->
    <b-modal
      id="modal-status"
      centered
      title="حالة القبول"
      title-class="font-18"
      @hidden="resetModal"
      hide-footer
    >
      <b-form>
        <AlertError
          v-if="showModel"
          :showDismissibleAlert="showAlert"
          :errors="errors"
        ></AlertError>
        <div class="row mt-1">
          <b-form-group
            class="col-md-12 mb-3"
            label="اختر حالة القبول :"
            label-for="status"
          >
            <select
              class="form-control select-p"
              :class="{ 'is-invalid': submited && $v.status.$error }"
              v-model="status"
              size="sm"
            >
              <option v-for="status in statusList" :value="status.id" :key="status.id">
                {{ status.title }}
              </option>
            </select>
            <div v-if="submited && $v.status.$error" class="invalid-feedback">
              <span v-if="!$v.status.required"> هذا الحقل الزامي </span>
            </div>
          </b-form-group>

          <b-form-group class="col-md-12 mb-3" label="الملاحظة :" label-for="status_note">
            <textarea
              id="status_note"
              v-model="status_note"
              class="form-control"
              :class="{ 'is-invalid': submited && $v.status_note.$error }"
              rows="5"
            ></textarea>
            <div v-if="submited && $v.status_note.$error" class="invalid-feedback">
              <span v-if="!$v.status_note.maxLength">
                قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 1000 حرف على الاكثر .
              </span>
            </div>
          </b-form-group>
        </div>
        <div class="row mt-3">
          <div class="col-md-12 d-flex justify-content-between">
            <b-button
              :disabled="loadingButton || !this.dataChange()"
              @click="saveStatus()"
              variant="primary"
              type="button"
              class="me-2"
            >
              <b-spinner v-if="loadingButton" small></b-spinner>
              <span v-else
                ><i class="bx bx-check font-size-16 align-middle me-2"></i>حفظ</span
              >
            </b-button>
            <b-button class="" block @click="$bvModal.hide('modal-status')"
              >اغلاق</b-button
            >
          </div>
        </div>
      </b-form>
    </b-modal>
    <!-- end modal-pdf -->

    <Loader :loading="showLoader">
      <div class="row mt-3">
        <div class="col-12">
          <AlertError
            v-if="!showModel"
            :showDismissibleAlert="showAlert"
            :errors="errors"
          ></AlertError>

          <!-- Header Table -->
          <div class="row mt-1">
            <!-- table_length -->
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                  عرض&nbsp;:&nbsp;
                  <b-form-select
                    class="form-select form-select-sm"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                  &nbsp;مدخلات
                </label>
              </div>
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                <label class="d-inline-flex align-items-center">
                  بحث&nbsp;:&nbsp;
                  <b-form-input
                    v-model="filter"
                    @input="search"
                    type="search"
                    placeholder="بحث..."
                    class="form-control form-control-sm ms-2"
                  ></b-form-input>
                </label>
                <b-button class="btn-sm mx-2" variant="primary" @click="exportTable"
                  >Excel</b-button
                >
              </div>
            </div>
          </div>

          <!-- Table -->
          <div class="table-responsive mb-0">
            <b-table
              class="datatables"
              show-empty
              hover
              :items="items"
              :striped="true"
              :fields="visibleFields()"
              responsive="md"
              :current-page="currentPage"
              :per-page="0"
              :key="tableKey"
            >
              <!-- A virtual column -->
              <template #cell(index)="data">
                {{ data.index + 1 + (currentPage - 1) * perPage }}
              </template>

              <!-- A custom formatted column Status -->
              <template v-slot:cell(status)="data">
                <span
                  class="badge btn-settings-scholar_ships rounded-5 p-2"
                  style="width: 75px"
                  :class="statusClassList[data.item.student_status.name]"
                  >{{ data.item.student_status.title }}</span
                >
              </template>

              <!-- A custom formatted column Sutting -->
              <template v-slot:cell(settings)="data">
                <router-link
                  v-can="'show_details_scholarships'"
                  :to="{ name: 'scholar_ships.details', params: { id: data.item.id } }"
                >
                  <b-button class="btn-sm btn-settings-scholar_ships me-1" variant="info"
                    >التفاصيل</b-button
                  >
                </router-link>

                <b-button
                  class="btn-sm btn-settings-scholar_ships me-1"
                  v-b-modal.modal-pdf
                  @click="showPDF(data.item.id)"
                  >pdf</b-button
                >

                <b-button
                  v-can="'update_status_scholarships'"
                  class="btn-sm btn-settings-scholar_ships me-1"
                  variant="primary"
                  @click="showStatus(data.item.id)"
                  >حالة القبول</b-button
                >

                <b-button
                  v-can="'delete_scholarships'"
                  class="btn-sm btn-settings-scholar_ships"
                  variant="danger"
                  title="حذف"
                  @click="deleteItem(data.item.id)"
                  ><i class="bx bx-trash"></i
                ></b-button>
              </template>
            </b-table>
          </div>

          <!-- Footer Table -->
          <div class="row">
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalItemsFiltered"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
              <div class="dataTables_paginate paging_simple_numbers float-start">
                <p>
                  عرض من {{ start }} الى {{ end }} من مجموع {{ totalItemsFiltered }}
                  <spam v-if="totalItemsFiltered != totalItems"
                    >(تمت تصفيته من إجمالي {{ totalItems }} إدخالاً)</spam
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Loader>
  </div>
</template>
